<template>
  <section class="task-variant-content" :class="{ 'task-variant-content--dark': isDarkMode }">
    <div class="task-variant-content-title"><v-icon small color="primary">mdi-text-box-outline</v-icon> Inhalt für dieses Studio</div>
    <v-text-field
      v-if="templateData.supportsVariants"
      v-model="templateData.variantName"
      label="Variantenname"
      placeholder="z. B. Wellnessbereich"
      :hint="templateData.isNewStudioVariant || templateData.parentTemplateId || templateData.isGroupedVariant ? 'Ein kurzer Name für diese Variante.' : 'Die bisherige Aufgabe bleibt als Standard erhalten. Du kannst ihr hier einen Namen geben.'"
      persistent-hint outlined dense maxlength="80" :dark="isDarkMode" />
    <v-textarea v-model="templateData.description" label="Beschreibung / Anleitung" placeholder="Was soll das Team bei dieser Aufgabe machen?"
      outlined auto-grow rows="3" maxlength="12000" hide-details="auto" :dark="isDarkMode" class="mb-4" />
    <v-textarea v-model="templateData.instructions" label="Zusätzliche Hinweise (optional)" outlined auto-grow rows="2"
      maxlength="12000" hide-details="auto" :dark="isDarkMode" class="mb-4" />
    <div class="task-variant-checklist-header">
      <strong>Checkliste <span>optional</span></strong>
      <v-btn small text color="primary" :disabled="templateData.checklist.length >= 100" class="text-none" @click="addStep"><v-icon left small>mdi-plus</v-icon>Schritt hinzufügen</v-btn>
    </div>
    <div v-for="(item, index) in templateData.checklist" :key="index" class="task-variant-step">
      <span>{{ index + 1 }}</span>
      <v-text-field v-model="item.text" :label="'Arbeitsschritt ' + (index + 1)" outlined dense hide-details maxlength="2000" :dark="isDarkMode" />
      <v-btn icon :aria-label="'Arbeitsschritt ' + (index + 1) + ' entfernen'" @click="templateData.checklist.splice(index, 1)"><v-icon small>mdi-close</v-icon></v-btn>
    </div>
    <p class="task-variant-content-note">Neue Kalenderaufgaben übernehmen diesen Inhalt. Bereits eingeplante Aufgaben behalten ihre gespeicherte Anleitung.</p>
  </section>
</template>

<script>
export default {
  name: "WorkCalendarTaskVariantContent",
  props: { templateData: { type: Object, required: true }, isDarkMode: { type: Boolean, default: false } },
  methods: {
    addStep() { this.templateData.checklist.push({ text: "", isDone: false }) },
  },
}
</script>

<style scoped>
.task-variant-content { border: 1px solid #dfe6ee; border-radius: 14px; padding: 20px; margin-bottom: 20px; }
.task-variant-content--dark { border-color: #39414d; }
.task-variant-content-title { display: flex; align-items: center; gap: 9px; font-weight: 700; margin-bottom: 18px; }
.task-variant-checklist-header { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 8px; }
.task-variant-checklist-header strong { font-size: 13px; }
.task-variant-checklist-header strong span { font-weight: 400; color: #778498; padding-left: 5px; }
.task-variant-step { display: flex; align-items: center; gap: 10px; margin-top: 10px; }
.task-variant-step > span { font-size: 12px; color: #778498; min-width: 14px; }
.task-variant-content-note { font-size: 12px; color: #637287; margin: 18px 0 0; }
.task-variant-content--dark .task-variant-content-note { color: #adb8c8; }
@media (max-width: 600px) { .task-variant-content { padding: 14px; } .task-variant-checklist-header .v-btn { min-height: 42px; } }
</style>
